<div class="grid flex-column">
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="manCliLabel" [parentCompany]="0" [selectedID]="document.DOCMANCLIID" disabled="true"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="manPerLabel" [parentCompany]="document.DOCMANCLIID" [selectedID]="document.DOCMANPERID" disabled="true" (selectedPersonID)="mainPersonSelected($event)"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="manDepLabel" [parentCompany]="document.DOCMANCLIID" [selectedID]="document.DOCMANDEPID" (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="lcoCliLabel" [parentCompany]="document.DOCMANCLIID" [selectedID]="document.DOCLCOCLIID" (selectedCompanyID)="lcoCompanySelected($event)" disabled="true"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="lcoPerLabel" [parentCompany]="document.DOCLCOCLIID" [selectedID]="document.DOCLCOPERID" select="sign" (selectedPersonID)="lcoPersonSelected($event)"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="lcoDepLabel"
                                [disabled]="true"
                                [parentCompany]="document.DOCLCOCLIID"
                                [selectedID]="document.DOCLCODEPID"
                                [masterID]="document.DOCMANDEPID"
                                (selectedDepartmentID)="lcoStockSelected($event)">
        </app-departmentselector>
      </div>
    </div>
  </div>
</div>
